export default "/ssamziegil.glb";